
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/business/[post]",
      function () {
        return require("private-next-pages/business/[post].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/business/[post]"])
      });
    }
  